module.exports = __webpack_public_path__ + "img/s1_t1_23.7e9c75ca.jpeg";